export const getItem = (item) => {
  try {
    const serializedItem = localStorage.getItem(item);
    if (serializedItem == null) {
      return undefined;
    }
    return JSON.parse(serializedItem);
  } catch (e) {
    return undefined;
  }
};

export const setItem = (key, value) => {
  try {
    const serializedItem = JSON.stringify(value);
    localStorage.setItem(key, serializedItem);
  } catch (e) {
    console.log(e.message);
  }
};

export const removeItem = (key) => {
  try {
    localStorage.removeItem(key);
  } catch (e) {
    console.log(e.message);
  }
};
